import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "statistics-public export-page" }
const _hoisted_2 = {
  key: 0,
  class: "statistics-public__body container-page big export-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticsPublicExportButtons = _resolveComponent("StatisticsPublicExportButtons")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_StatisticsPublicFilter = _resolveComponent("StatisticsPublicFilter")!
  const _component_StatisticsPublicVisitsCountTabs = _resolveComponent("StatisticsPublicVisitsCountTabs")!
  const _component_StatisticsPublicViewsCountTabs = _resolveComponent("StatisticsPublicViewsCountTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      dense: "",
      title: "Статистика посещений. Публичная часть"
    }, _createSlots({ _: 2 }, [
      (_ctx.isAccessAllowed)
        ? {
            name: "button",
            fn: _withCtx(() => [
              _createVNode(_component_StatisticsPublicExportButtons, { filter: _ctx.filter }, null, 8, ["filter"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1024),
    (_ctx.isAccessAllowed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_StatisticsPublicFilter, { onSearchFilter: _ctx.searchFilter }, null, 8, ["onSearchFilter"]),
          _createVNode(_component_StatisticsPublicVisitsCountTabs, { filter: _ctx.filter }, null, 8, ["filter"]),
          _createVNode(_component_StatisticsPublicViewsCountTabs, { filter: _ctx.filter }, null, 8, ["filter"])
        ]))
      : _createCommentVNode("", true)
  ]))
}